import { render, staticRenderFns } from "./productDetail2.vue?vue&type=template&id=11b9c1a4"
import script from "./productDetail2.vue?vue&type=script&lang=js"
export * from "./productDetail2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports